import { generate_contract_number } from '@/api/trade_contract'

export function timeFix () {
  const time = new Date()
  const hour = time.getHours()
  return hour < 9 ? '早上好' : hour <= 11 ? '上午好' : hour <= 13 ? '中午好' : hour < 20 ? '下午好' : '晚上好'
}

export function welcome () {
  const arr = ['休息一会儿吧', '准备吃什么呢?', '要不要打一把 DOTA', '我猜你可能累了']
  const index = Math.floor(Math.random() * arr.length)
  return arr[index]
}

/**
 * 触发 window.resize
 */
export function triggerWindowResizeEvent () {
  const event = document.createEvent('HTMLEvents')
  event.initEvent('resize', true, true)
  event.eventType = 'message'
  window.dispatchEvent(event)
}

export function handleScrollHeader (callback) {
  let timer = 0

  let beforeScrollTop = window.pageYOffset
  callback = callback || function () {}
  window.addEventListener(
    'scroll',
    event => {
      clearTimeout(timer)
      timer = setTimeout(() => {
        let direction = 'up'
        const afterScrollTop = window.pageYOffset
        const delta = afterScrollTop - beforeScrollTop
        if (delta === 0) {
          return false
        }
        direction = delta > 0 ? 'down' : 'up'
        callback(direction)
        beforeScrollTop = afterScrollTop
      }, 50)
    },
    false
  )
}

export function isIE () {
  const bw = window.navigator.userAgent
  const compare = (s) => bw.indexOf(s) >= 0
  const ie11 = (() => 'ActiveXObject' in window)()
  return compare('MSIE') || ie11
}

/**
 * Remove loading animate
 * @param id parent element id or class
 * @param timeout
 */
export function removeLoadingAnimate (id = '', timeout = 1500) {
  if (id === '') {
    return
  }
  setTimeout(() => {
    document.body.removeChild(document.getElementById(id))
  }, timeout)
}

/**
 * 过滤查找审批分类的value
 * @param targetKey
 * @param categories
 * @returns {number|*|(number|*|没有找到)[]|undefined}
 */
export function getValueByKey (targetKey, categories = this.$Dictionaries.approval_category) {
  function findPath (items, key, path = []) {
    for (const item of items) {
      if (item.key === key) {
        return [...path, item.value]
      }

      if (item.children) {
        const result = findPath(item.children, key, [...path, item.value]) // 把父级 value 加入路径
        if (result.length > 0) {
          return result
        }
      }
    }
    return [] // 没找到返回空数组
  }
  return findPath(categories, targetKey)
  // for (const node of categories) {
  //   // 先检查当前节点是否匹配 key
  //   console.log('===========', node.key, targetKey)
  //   if (node.key === targetKey) {
  //     return node.value
  //   }
  //   console.log('===========>>>>>>', node.children)
  //   // 如果有 children，继续递归查找
  //   if (node.children && node.children.length > 0) {
  //     const result = getValueByKey(targetKey, node.children)
  //     if (result !== null) {
  //       // 如果找到的是子节点，返回 [父级 value, 子级 value]
  //       return [node.value, result]
  //     }
  //   }
  // }
  // return undefined // 没有找到
}

export function tradeGenerateContractNumber (self, project_id, finallyCall) {
  const contract_code = self.$Dictionaries.trade_contract_type_number[self.$route.path.substring(self.$route.path.lastIndexOf('/') + 1)]
  return generate_contract_number({ project_id: project_id, contract_code: contract_code }).then(res => {
    if (res.code === 1000) {
      return Promise.resolve(res.data)
    } else {
      return Promise.reject(new Error(res.msg || '生成合同编号失败'))
    }
  }).finally(() => {
    if (typeof finallyCall === 'function') {
      finallyCall()
    }
  })
}
